import { Grid } from "@mui/material";
import { useSelector } from "react-redux";

const Videos = ({ searchTermChanged, scrolled }) => {
  const myVideo = useSelector((s) => s.myVideo.data);
  const loading = useSelector((s) => s.myVideo.loading);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} lg={8}></Grid>

        <Grid item xs={12} lg={4}></Grid>
      </Grid>
    </>
  );
};

export default Videos;
